import React from 'react';
import PropTypes from 'prop-types';

import {userShape} from '../../utils';

import StyledNoDataTemplate from './StyledNoDataTemplate';

const NoDataTemplate = ({user}) => {
	const props = {};

	return (
		<StyledNoDataTemplate useTypography={false} title={user?.displayName}>
			{user?.initials}
		</StyledNoDataTemplate>
	);
};

NoDataTemplate.propTypes = {
	user: userShape
};

export default NoDataTemplate;
